import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Search, Close } from "@mui/icons-material";
import _, { debounce } from "lodash";
import { toast } from "react-toastify";
import { GetError } from "src/constant";
import { getSearchResultData, getSearchSelectResultData, getAllSearchResultData } from "src/thunks/search";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg"

export const SearchHeader = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const { allSearchResultData } = useSelector((state) => state.search);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);

  /** hooks useState ----------------------------------------------------- **/
  const [isOpen, setOpen] = useState(false);
  const [searchResultList, _searchResultList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const dropdownRef = useRef(null);

  /** Variable declaration ----------------------------------------------------- **/
  const getSearchValueFromLocalStorage = localStorage.getItem("searchValue") || "";

  /** hooks useEffect----------------------------------------------------- **/

  useEffect(() => {
    if (getSearchValueFromLocalStorage == "") {
      handleClearSearchText();
    }
  }, [getSearchValueFromLocalStorage])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /** handler functions--------------------------------------------------- **/

  /** Function to retrieve corresponding matching item numbers entered in the search from the backend and save them into the state. ------------------------**/
  const getSearchOption = async (nextValue) => {
    try {
      let params = { ItemNumber: nextValue };
      let data = await dispatch(getSearchResultData({ ...params })).unwrap();
      _searchResultList(data);
      setOpen(!isOpen)
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const debouncedSave = useCallback(
    debounce(nextValue => getSearchOption(nextValue), 1000),
    [],
  );

  /** Function to save entered search value in state -------------------------------------- **/
  const handleSearchInputChange = async (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
    localStorage.setItem("searchValue", searchText)
    debouncedSave(searchText);
  }

  /** Function to clear the entered search value ----------------------------------------------- **/
  const handleClearSearchText = async () => {
    handleSearchInputChange({ target: { value: "" } })
    _searchResultList([])
    let data = { id: "" };
    await dispatch(getSearchSelectResultData({ ...data })).unwrap();
  }

  /** Function execute when user click on one of the searched ItemNumber and just filter the data based on selected ItemNumber and saved in state. ----------------------------- **/
  const getSearchResultDataForTable = async (item) => {
    try {
      let data = { id: item.itemNumber };
      let res = await dispatch(getSearchSelectResultData({ ...data })).unwrap();
      setOpen(!isOpen);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  /** Function executes when the user enters an item number to search and presses enter, displaying all data related to the entered item number from the search. ------------------- **/
  const handleKeyDown = async (event) => {
    if (event.key === 'Enter') {
      setOpen(!isOpen)
      await dispatch(getAllSearchResultData(getSearchValueFromLocalStorage=="" ? [] : allSearchResultData))
    }
  };

  const handleSearchInputClick = () => {
    debouncedSave(getSearchValueFromLocalStorage);
  }


  return (
    <>
      <div className={`d-flex align-items-center main-header-div ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""}`} style={{ flex: 10 }}>
        <div style={{ flex: 1 }} className="ms-2">
          <img width={90} height={35} src={SigmaLogo} alt="muz image" />
        </div>
        <div style={{ flex: 2 }} className="serach-header-text-style">
          SEARCH BY ITEM NUMBER
        </div>
        <div style={{ flex: 7, position: "relative" }} className="me-2">
          <input className="search-input-for-search-header" style={{ width: "100%", position: "relative" }} type="text" onKeyDown={handleKeyDown} onClick={handleSearchInputClick} onChange={handleSearchInputChange}
            value={getSearchValueFromLocalStorage}
          />
          {getSearchValueFromLocalStorage !== "" ? <Close style={{ cursor: "pointer", color: "#FFFFFF" }} onClick={handleClearSearchText} className="search-icon-depotpersonal-style" /> :
            <Search style={{ color: "#FFFFFF" }} className="search-icon-depotpersonal-style" />}

          {isOpen && searchResultList && searchResultList[0] && (
            <div ref={dropdownRef} className="search-dropdown-content">
              <div className="mt-4">
                {searchResultList && searchResultList[0] && searchResultList.map((d, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="d-flex flex-column item-search-style" onClick={() => getSearchResultDataForTable(d)}>
                        {d.itemNumber}
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </div >
    </>
  );
}


